import * as React from "react";
import { Fragment } from "react";
import { CgEye } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

import pages from "../../../constants/pages";
import { Chip, TextAvatar } from "../../../components";
import { colors } from "../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors?.sideBarColor};
  color: ${colors?.sideBarColor};
  height: 40px;
  width: 40px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors?.sideBarColor};
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.iconColor,
    color: "#fff",
    fontSize: "11px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    backgroundColor: "#F9F9F9",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
    fontSize: "12px",
  },
  "&:nth-of-type(2n+1)": {
    backgroundColor: "rgba(249, 249, 249, 1)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function List({ usersData }) {
  const navigate = useNavigate();

  return (
    <TableContainer
      sx={{ maxHeight: "90%", borderRadius: "10px" }}
      component={Paper}
    >
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell />

            <StyledTableCell>User Name</StyledTableCell>
            <StyledTableCell>Brand</StyledTableCell>
            <StyledTableCell>Role</StyledTableCell>
            <StyledTableCell>Email</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
            <StyledTableCell>Action</StyledTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {usersData?.users?.map((user, index) => (
            <StyledTableRow>
              <Fragment>
                <StyledTableCell component="th" scope="row">
                  <TextAvatar
                    size={{
                      height: "30px",
                      width: "30px",
                    }}
                    userName={user.given_name}
                  />
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {user.given_name}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {usersData.brand.brand_name}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {user.brand_user_role}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  {user.email}
                </StyledTableCell>

                <StyledTableCell component="th" scope="row">
                  <StatusChip user={user} />
                </StyledTableCell>

                <StyledTableCell style={{ display: "flex" }}>
                  <Tooltip title="View Campaign">
                    <Icon>
                      <CgEye
                        onClick={() =>
                          navigate(pages.userDetails.route + user.user_id)
                        }
                        style={{ height: "20px", width: "20px" }}
                      />
                    </Icon>
                  </Tooltip>
                </StyledTableCell>
              </Fragment>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );

  function StatusChip({ user }) {
    let color;
    let label;
    if (user.account_status === 0) {
      color = colors.yellow;
      label = "Unverified";
    }

    if (user.account_status === 1) {
      color = colors.green;
      label = "Accepted";
    }

    if (user.account_status === 2) {
      color = colors.error;
      label = "Blocked";
    }

    if (user.account_status === 3) {
      color = colors.error;
      label = "Rejected";
    }

    if (user.account_status === 4) {
      color = colors.error;
      label = "Suspended";
    }

    if (user.account_status === 5) {
      color = colors.error;
      label = "Deleted";
    }

    return (
      <Chip
        style={{
          position: "relative",
          left: "-13px",
          fontSize: "13px",
          backgroundColor: color,
          color: "#fff",
        }}
        label={label}
      />
    );
  }
}
